import { useEffect, useState } from 'react';
import { listAccount } from 'services/accountServices';
import { totalCountEvent } from 'services/generalServices';

export function useAccounts(params) {
  const { accountType = '', shouldCallListAccountApi = true, excludeFromLoading = false } = params || {};
  const [List, setList] = useState([]);
  const [isAccountsLoading, setIsAccountsLoading] = useState(false);

  const listAccounts = () => {
    setIsAccountsLoading(true);
    totalCountEvent('account')
      .then((response) => {
        const pageLimit = response?.data;
        const paginationToken = '';
        const paginationDirection = 'forward';
        const next = '';

        const payloadData = {
          account_type: accountType,
        };

        listAccount(pageLimit, paginationToken, paginationDirection, next, payloadData, excludeFromLoading)
          .then((res) => {
            setList(res.data?.account);
          })
          .catch((error) => console.error(error))
          .finally(() => setIsAccountsLoading(false));
      })
      .catch((err) => {
        setIsAccountsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (shouldCallListAccountApi) listAccounts();
  }, []);

  return { accountList: List, isAccountsLoading };
}
